module.exports = __webpack_public_path__ + "static/lando-tablet-cover-0b970a07ba74ff9a9710e7df7e31fc07.png";